<template>
    <div>
        <v-dialog v-model="dialog_history" max-width="1024">
            <v-card>
                <v-simple-table fixed-header align="left" >
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">สถานะ</th>
                        <th class="text-left">สำหรับนัดหมาย</th>
                        <th class="text-left">แก้ไขโดย</th>
                        <th class="text-left">แก้ไขเมื่อ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in reservation_history" :key="item.group_id">
                            <td>{{ $t('reservation_status_to_'+item.reservation_status_id_to) }}</td>
                            <td><div>{{ item.reservation_date.substring(0,10) }}</div><div>{{ item.reservation_timestart + ' - ' +  item.reservation_timeend}}</div></td>
                            <td>{{ item.displayname }}</td>
                            <td>{{ item.create_date }}</td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_history_member" max-width="800">
            <v-card>
                <v-simple-table fixed-header align="left" >
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">กลุ่มงานบริการ</th>
                        <th class="text-left">เวลานัดหมาย</th>
                        <th class="text-left">สถานะ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in reservation_history_member" :key="item.group_id">
                            <td>{{ item.group_name }}</td>
                            <td>{{ item.reservation_date.substring(0,10) + ' ' + item.reservation_timestart + ' - ' +  item.reservation_timeend }}</td>
                            <td>{{ item.status }}</td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-dialog>

        <div align="right" class="mb-4 mr-8">
            <v-switch  
            @change="switchStatusTime"
            label="แสดงเวลาอัพเดทล่าสุด"></v-switch>
        </div>

        <v-data-table
            :headers="headers"
            :items="rows"
            :items-per-page="10"
            class="elevation-1"

            :custom-sort="customSort"

            v-model="selected"
            :single-select="false"
            show-select
            item-key="reservation_id"
            @input="onInput"
        >

            <template v-slot:item.reservation_status_id="{ item }">
                <div v-if="item.callback_status!=undefined">
                    <div v-if="item.callback_status.type=='call_wait'">
                        <div v-if="item.callback_status.is_completed > 0">
                            {{ $t('reservation_status_' + item.reservation_status_id) }}
                        </div>
                        <div v-else-if="item.callback_status.is_called > 0">
                            <v-btn :loading="item.loading" depressed color="yellow" @click="callWait(item.reservation_id,1,0)">{{ $t('callback_status_call_wait_called') }} {{item.callback_status.is_called}} {{ $t('callback_status_call_wait_time') }}</v-btn>
                            <v-btn class="ml-1" depressed color="red" @click="callWait(item.reservation_id,0,1)">{{ $t('callback_status_call_wait_complete') }}</v-btn>
                        </div>
                        <div v-else>
                            <v-btn :loading="item.loading" depressed color="green" @click="callWait(item.reservation_id,1,0)">{{ $t('callback_status_call_wait_calling') }}</v-btn>
                            <v-btn class="ml-1" depressed color="red" @click="callWait(item.reservation_id,0,1)">{{ $t('callback_status_call_wait_complete') }}</v-btn>
                        </div>
                    </div>
                    <div v-else>{{ $t('reservation_status_' + item.reservation_status_id) }}</div>
                </div>
                <div v-else>{{ $t('reservation_status_' + item.reservation_status_id) }}</div>
            </template>

            <template v-slot:item.status_datetime="{ item }">
                <div>{{ item.status_datetime.substring(0,10) + ' ' + item.status_datetime.substring(11,19) }}</div>                      
            </template>

            <template v-slot:item.history="{ item }">
                            <v-btn fab outlined
                x-small
                dark color="primary" @click="onHistory(item)"><v-icon>mdi-history</v-icon></v-btn>                    
            </template>

            <template v-slot:item.reservation_date="{ item }">
                <div class="d-none">{{ item.reservation_datestart }}</div>
                <div>{{ item.reservation_date.substring(0,10) }}</div>
                <div>{{ item.reservation_timestart + ' - ' +  item.reservation_timeend}}</div>
                <div v-if="item.activate_intime" :style="item.activate_intime == 'activate_before' ? 'color: darkorange;' : item.activate_intime == 'activate_late' ? 'color: red;' : 'color: grey;'">{{ item.activate_intime == 'activate_before' ? 'มาก่อนเวลา' : item.activate_intime == 'activate_late' ? 'มาเกินเวลา' : 'มาตรงเวลา'  }}</div>
            </template>

            <template v-slot:item.line_name="{ item }">
                <div>{{ item.line_name }}</div>
            </template>

            <template v-slot:item.group_name="{ item }">
                <div>{{ item.group_name }}</div>
                <div v-if="item.extranote!=undefined" style="color:grey;" class="text-caption">{{ item.extranote }}</div>
            </template>

            <template v-slot:item.historymember="{ item }">
                            <v-btn fab outlined
                x-small
                dark color="primary" @click="onHistoryMember(item)"><v-icon>mdi-history</v-icon></v-btn>                    
            </template>

        </v-data-table>
    </div>
</template>


<script>

  import axios from 'axios';
  import config from '@/../config.js'
  import Staff from '@/model/instance/Staff.js'

  export default {
    props: ['query','station_code'],
    data () {
        return {
            selected : [],
            itemsTotal : 0,
            headers:[
                {text: 'สถานะ', value: 'reservation_status_id'},
                {},
                //{text: 'อัพเดทเมื่อ', value: 'status_datetime' ,width:"10%"},
                {text: '', value: 'history'},
                {text: 'กลุ่มงานบริการ', value: 'group_name'},
                {text: 'วันเวลาที่จอง', value: 'reservation_date'},
                {text: 'LINE', value: 'line_name'},
                {text: '', value: 'historymember'},
                {text: 'member_form_1', value: 'member_form_1' ,width:"8%"},
                {text: 'member_form_2', value: 'member_form_2' ,width:"8%"},
                {text: 'member_form_3', value: 'member_form_3' ,width:"8%"},
                {text: 'member_form_4', value: 'member_form_4' ,width:"8%"},
                {text: 'member_form_5', value: 'member_form_5' ,width:"8%"},
            ],
            rows: [],
            registerformlist : [],
            dialog_history : false,
            dialog_history_member : false,
            reservation_history : [],
            reservation_history_member : []
        }
    },
    mounted() {
        var que = this.$store.commit('addLoading')
        axios.post(config.api.url.public.station.get_registerform,{station_code:this.station_code})
        .then(response => {

            this.registerformlist = response.data.registerformlist

            for(var j=5;j>0;j--){
                this.headers.forEach((v,i,arr)=>{
                    if(v.value=='member_form_'+j){
                        if(this.registerformlist.length>=j){
                            arr[i].text = this.$i18n.t('form_tag_'+this.registerformlist[j-1].form_tag)
                        }else{
                            arr.splice(i, 1);
                        }
                    }
                })
            }
            
            this.$store.commit('finishLoading',que)
        })
    },
    methods : {
        switchStatusTime : function(val){
            this.headers = this.headers.slice()
            this.headers[1] = val ? {text: 'อัพเดทเมื่อ', value: 'status_datetime' ,width:'10%'} : {}
        },
        reload : function() {
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.manage.appointmentlistsize,this.query,{ headers: Staff.getTokenHeader()})
            .then(response => {
                this.itemsTotal = response.data
                return axios.post(config.api.url.manage.appointment.manage.appointmentlist,this.query,{ headers: Staff.getTokenHeader()})
            }).then(response => {
                this.selected = []
                this.rows = response.data.reservationlist
                this.rows.forEach((r,i,arr)=>{
                    
                    var d = new Date(r.reservation_date);
                    d.setHours(d.getHours()+7);
                    arr[i]['reservation_date'] = d.toISOString().substring(0,10);

                    d = new Date(r.status_datetime);
                    d.setHours(d.getHours()+7);
                    arr[i]['status_datetime'] = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);

                    r.reservation_timestart = '0000' + r.reservation_timestart;
                    r.reservation_timestart = r.reservation_timestart.substring(r.reservation_timestart.length-4,r.reservation_timestart.length);
                    arr[i]['reservation_timestart']  = r.reservation_timestart.substring(0,2) + ":" + r.reservation_timestart.substring(2,4);
                    r.reservation_timeend = '0000' + r.reservation_timeend;
                    r.reservation_timeend = r.reservation_timeend.substring(r.reservation_timeend.length-4,r.reservation_timeend.length);
                    arr[i]['reservation_timeend']  =  r.reservation_timeend.substring(0,2) + ":" + r.reservation_timeend.substring(2,4);
                                

                    if([4,5].includes(r.reservation_status_id)){
                        arr[i]['activate_intime'] = 'activate_intime'
                        if(new Date(r.status_datetime)>new Date(r.reservation_dateend)){
                            arr[i]['activate_intime'] = 'activate_late'
                        }if(new Date(r.status_datetime)<new Date(r.reservation_datestart)){
                            arr[i]['activate_intime'] = 'activate_before'
                        }

                        
                    }

                    for(var j=1;j<=5;j++){
                        if(this.headers.some(i=>i.value=='member_form_'+j)){
                            if(arr[i]['member_form_'+j] != undefined && arr[i]['member_form_'+j].length > 0){
                                if(this.registerformlist[j-1].value_type_id==1){
                                    arr[i]['member_form_'+j] = arr[i]['member_form_'+j].split(',').join(' ')
                                }else if(this.registerformlist[j-1].value_type_id==2){
                                    arr[i]['member_form_'+j] = arr[i]['member_form_'+j].split(',')[1]
                                }
                            }
                        }
                    }

                })
                this.$store.commit('finishLoading',que)
            })
        },
        customSort: function(items, index, isDesc) {
            console.log(items)
            items.sort((a, b) => {
                if (['status_datetime'].includes(index[0])) {
                    if (!isDesc[0]) {
                        return new Date(b[index]) - new Date(a[index]);
                    } else {
                        return new Date(a[index]) - new Date(b[index]);
                    }
                }else if(['reservation_status_id'].includes(index[0])){
                    if (!isDesc[0]) {
                        return b[index] - a[index]
                    } else {
                        return a[index] - b[index]
                    }
                }else if(['reservation_date'].includes(index[0])){
                    if (!isDesc[0]) {
                        return new Date(b['reservation_datestart']) - new Date(a['reservation_datestart']);
                    } else {
                        return new Date(a['reservation_datestart']) - new Date(b['reservation_datestart']);
                    }
                }else if(['historymember','history'].includes(index[0])){
                    return items;
                }
                else {
                    if(typeof a[index] !== 'undefined'){
                        if (!isDesc[0]) {
                            return a[index].localeCompare(b[index],'th');
                        }
                        else {
                            return b[index].localeCompare(a[index],'th');
                        }
                    }
                }
            });
            return items;
        },
        onHistoryMember(item){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.manage.appointmentlist
            ,{ station_code : this.$route.params.station_code
                ,fields : ["reservation_status_id","group_name","reservation_date","reservation_timestart","reservation_timeend","reservation_completed_datetime","reservation_datestart","reservation_dateend","status_datetime"]
                ,query : {
                    station_code_list:[this.$route.params.station_code]
                    ,status_id_list:["4","5","9"]
                    ,member_id:item.member_id
                }
                ,order : "reservation_dateend desc"
                ,page : 1
                ,limit : 5
            }
            ,{ headers: Staff.getTokenHeader()})
            .then(response => {
                this.reservation_history_member = response.data.reservationlist
                this.reservation_history_member.forEach((r,i,arr)=>{
                    var d = new Date(r.reservation_date);
                    d.setHours(d.getHours()+7);
                    arr[i]['reservation_date'] = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);
                    r.reservation_timestart = '0000' + r.reservation_timestart;
                    r.reservation_timestart = r.reservation_timestart.substring(r.reservation_timestart.length-4,r.reservation_timestart.length);
                    arr[i]['reservation_timestart']  = r.reservation_timestart.substring(0,2) + ":" + r.reservation_timestart.substring(2,4);
                    r.reservation_timeend = '0000' + r.reservation_timeend;
                    r.reservation_timeend = r.reservation_timeend.substring(r.reservation_timeend.length-4,r.reservation_timeend.length);
                    arr[i]['reservation_timeend']  =  r.reservation_timeend.substring(0,2) + ":" + r.reservation_timeend.substring(2,4);
                
                    if(r.reservation_status_id==9){
                        arr[i]['status'] = "ไม่มาตามนัด"
                    }else{
                        var activate_date = new Date(r.status_datetime)
                        var dateend = new Date(r.reservation_dateend)
                        var datestart = new Date(r.reservation_datestart)
                        if(activate_date<datestart){
                            arr[i]['status'] = "มาก่อนเวลานัด"
                        }else if(activate_date>dateend){
                            arr[i]['status'] = "มาหลังเวลานัด"
                        }else{
                            arr[i]['status'] = "มาตามเวลานัด"
                        }
                    }
                
                })
                this.dialog_history_member = true
                this.$store.commit('finishLoading',que)
            });
        },
        onHistory(item){
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.manage.get_appointmentlog,{reservation_id:item.reservation_id},{ headers: Staff.getTokenHeader()})
            .then(response => {
                this.reservation_history = response.data
                this.reservation_history = this.reservation_history.filter(r=>r.reservation_status_id_to != 1)
                this.reservation_history.forEach((r,i,arr)=>{
                    var d = new Date(r.create_date);
                    d.setHours(d.getHours()+7);
                    arr[i]['create_date'] = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);

                    d = new Date(r.reservation_date);
                    d.setHours(d.getHours()+7);
                    arr[i]['reservation_date'] = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);
                    r.reservation_timestart = '0000' + r.reservation_timestart;
                    r.reservation_timestart = r.reservation_timestart.substring(r.reservation_timestart.length-4,r.reservation_timestart.length);
                    arr[i]['reservation_timestart']  = r.reservation_timestart.substring(0,2) + ":" + r.reservation_timestart.substring(2,4);
                    r.reservation_timeend = '0000' + r.reservation_timeend;
                    r.reservation_timeend = r.reservation_timeend.substring(r.reservation_timeend.length-4,r.reservation_timeend.length);
                    arr[i]['reservation_timeend']  =  r.reservation_timeend.substring(0,2) + ":" + r.reservation_timeend.substring(2,4);

                })
                this.dialog_history = true
                this.$store.commit('finishLoading',que)
            });
        },
        onInput(items){
            this.$emit('ontable', items)
        },
        callWait(reservation_id,is_called,is_completed){
            this.rows.forEach((e,i,arr)=>{
                if(e.reservation_id == reservation_id){
                    arr[i].loading = true
                }
            })
            axios.post(config.api.url.manage.appointment.manage.edit_callback_callwait,{
                station_code : this.station_code
                ,reservation_id : reservation_id
                ,is_called : is_called
                ,is_completed : is_completed
            },{ headers: Staff.getTokenHeader()})
            .then(response => {
                if(is_called == 1){
                    this.rows.forEach((e,i,arr)=>{
                        if(e.reservation_id == reservation_id){
                            arr[i].loading = false
                            arr[i].callback_status.is_called = response.data.is_called
                        }
                    })
                }else if(is_completed == 1){
                    this.reload()
                }
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })

        }
    }
  }
</script>